export const bulb = () => (
  <path
    d="M9 22h6M8 9a4 4 0 014-4m7 3.955c0 1.803-.69 3.445-1.823 4.68-.734.801-1.398 1.706-1.593 2.775L15.11 19H8.89l-.473-2.59c-.195-1.069-.86-1.974-1.593-2.774A6.904 6.904 0 015 8.955C5 5.114 8.134 2 12 2s7 3.114 7 6.955z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
